import {Pbx} from "./pbx";

export class PbxMasterCreate extends Pbx {
    clientCredential: string;
    countryCode: string;
    areaCode: string;
    timeZone: string;
}
